import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id CB64EDBD-09A0-4085-BD1E-0D84EAA56297
 * name align-vertical-distribute
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/align-vertical-distribute.svg
 * tags
 * - Text / Content / Format 
 */
export const AlignVerticalDistributeIcon = createSvgIcon(<><path d="M22 2V4H2V2H22M7 10.5V13.5H17V10.5H7M2 20V22H22V20H2Z" /></>, 'AlignVerticalDistributeIcon');
export default AlignVerticalDistributeIcon